<template>
  <div class="signup uk-container uk-width-1-1">
    <form @submit.prevent="singup" class="uk-panel uk-panel-box uk-form">
      <div class="uk-margin">
        <input v-model="username" class="uk-width-1-1 uk-form-large" type="email" placeholder="Mail Address" required>
      </div>
      <div class="uk-margin">
        <input v-model="password" class="uk-width-1-1 uk-form-large" type="password" placeholder="Password" required>
      </div>
      <div class="uk-margin">
        <input v-model="passwordConfirm" class="uk-width-1-1 uk-form-large" type="password" placeholder="Password" required>
      </div>
      <div class="uk-margin">
        <input v-model="vendorId" class="uk-width-1-1 uk-form-large" type="text" max="7" maxlength="7" placeholder="Vendor ID" required>
      </div>
      <div class="uk-margin">
        <input v-model="productId" class="uk-width-1-1 uk-form-large" type="text" max="7" maxlength="7" placeholder="Product ID" required>
      </div>
      <div class="uk-margin">
        <button class="uk-width-1-1 uk-button uk-button-secondary uk-button-large">登録</button>
      </div>
    </form>
    <router-link to="/login">ログイン</router-link>
    <router-link to="/confirm">確認コード入力</router-link>
  </div>
</template>

<script>
export default {
  name: 'Signup',
  data () {
    return {
      username: '',
      password: '',
      passwordConfirm: '',
      vendorId: '',
      productId: ''
    }
  },
  methods: {
    singup () {
      if (this.username && (this.password === this.passwordConfirm)) {
        this.$cognito.signUp(this.username, this.password)
          .then(resutl => {
            // 登録に成功したら、確認コードの入力画面を表示
            this.$router.replace('/confirm')
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue